/**
 * The tap that has to wait to find out it was only a tap.
 *
 * The pegs of a played row answer a double tap by copying themselves into the
 * guess row, and the browser has no way of saying a click arrived alone - only
 * of not sending a second one. So a tap landing there cannot act as it lands:
 * it waits out the window a second press could still arrive in, and if one
 * does, it never acts at all.
 *
 * Only what is double-tapped waits. Everything else on the row - the score, the
 * space beside it - has no second gesture to be told apart from, and answers
 * the moment it is pressed.
 */

/**
 * How long a tap waits.
 *
 * Long enough to cover the gap between two taps of one double, short enough
 * that a tap meant on its own does not feel like it went unheard.
 */
export const DOUBLE_TAP_MS = 250;

export function createTap({ delay = DOUBLE_TAP_MS } = {}) {
    let timer = null;

    return {
        /**
         * Acts once the window has passed with no second press. A tap arriving
         * inside it replaces the one waiting rather than acting twice.
         */
        single(action) {
            this.cancel();
            timer = setTimeout(() => {
                timer = null;
                action();
            }, delay);
        },

        /** The double landing: whatever was waiting was never a single tap. */
        cancel() {
            if (timer) clearTimeout(timer);
            timer = null;
        },
    };
}
